<div class="file-uploader">
  @if (alwaysDisplayUploader || multiple || (!multiple && files.length === 0)) {
    <div
      class="file-uploader-drop-zone"
      [ngClass]="{
        'bg-subdued': isDragOver && !isDisabled,
        'opacity-70': isDisabled,
        'mb-2': files.length > 0,
        '!border-primary-500': invalid
      }"
      (dragover)="onDragOver($event)"
      (dragenter)="onDragEnter($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <div class="flex flex-col justify-center">
        <p
          class="text-base font-bold text-center"
          [innerHTML]="title | translate"></p>
        <span
          class="text-sm text-center opacity-60"
          translate
          [translateParams]="descriptionTranslateParams">
          {{ multiple ? "libs.file-uploader.drop-zone.multiple-description" : "libs.file-uploader.drop-zone.single-description" }}
        </span>
      </div>
      <input
        #fileSelector
        (click)="onFileClick($event)"
        (change)="onFileSelected($event)"
        type="file"
        hidden
        [disabled]="isDisabled"
        [accept]="config?.acceptedTypes"
        [multiple]="multiple" />
      <button
        mat-stroked-button
        type="button"
        color="secondary"
        class="small-button"
        [disabled]="isDisabled"
        (click)="fileSelector.click()">
        {{ (multiple ? "libs.file-uploader.button.multiple-text" : "libs.file-uploader.button.single-text") | translate }}
      </button>
    </div>
  }
  <div class="flex flex-col gap-4 w-full">
    @for (file of files; let index = $index; track index) {
      <rms-file-uploader-item
        [file]="file"
        [fileIcon]="fileIcon"
        [disabled]="isDisabled"
        (delete)="onDelete(index)" />
    }
  </div>
</div>
